import {Component, Input} from '@angular/core';
import {IncidentPriorityType} from '@npck/af-frontend-api';

@Component({
    selector: 'af-priority',
    templateUrl: './priority.component.html',
    styleUrl: './priority.component.scss',
    standalone: false
})
export class PriorityComponent {
    @Input() priorityLevel: IncidentPriorityType;
    priorityItems = [].constructor(3);
}
